import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getGlobalRules, ListNamesDictionary } from 'Services';
import { RQ_GLOBAL_RULES } from 'Utils';
import { transformServerData } from '../helper';

type Props = {
    users?: UsersHashmap;
    listNameMap?: ListNamesDictionary;
    showDeletedRule?: boolean;
    enable?: boolean;
    parameterData?: UseGetParametersResponse;
};

const useGlobalRules = ({ users, listNameMap, showDeletedRule, enable, parameterData }: Props) => {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery({
        queryKey: showDeletedRule
            ? [RQ_GLOBAL_RULES, templateRepositoryId] // sandbox + Ready To Delete rules
            : [RQ_GLOBAL_RULES, templateRepositoryId, !!showDeletedRule], // sandbox only rules
        queryFn: async () => {
            const data = await getGlobalRules(templateRepositoryId!, showDeletedRule);
            const tData = transformServerData({ t, users, listNameMap, parameterData })(data);
            return tData;
        },
        enabled: Boolean(templateRepositoryId) && enable !== false
    });
};

export default useGlobalRules;
